import { NavLink } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Badge } from '../ui/Badge';
import { navItems } from './navItems';

export function Sidebar() {
  const { tier, logout } = useAuthStore();

  return (
    <aside className="hidden md:flex w-64 h-screen fixed left-0 top-0 bg-surface border-r border-border flex-col">
      <div className="p-6">
        <h1 className="text-xl font-bold text-accent">Debt Chisel</h1>
      </div>

      <nav className="flex-1 px-3 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-accent/10 text-accent'
                  : 'text-muted hover:text-fg hover:bg-border/30'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-border">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-muted">Tier</span>
          <Badge variant={tier === 'PRO' ? 'accent' : 'default'}>{tier}</Badge>
        </div>
        <button
          onClick={logout}
          className="w-full text-sm text-muted hover:text-fg transition-colors text-left"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
